
export const CompanyData={
    short_name:"Valletech",
    name: "Valletech AB",
    address: "Nybohovsbacken 34 b Lgh 1101, 117-63 Stockholm, Sweden",
    short_address: "Nybohovsb.34b,11763 Sweden",    
    email: "info@valletech.eu",
    support_email: "support@valletech.eu",
    phone: "+46 723 199 055",
    org_number: "559067-3694",
    VAT: "SE559067369401",
    support_portal: "https://support.valletech.eu",
    linkedin_url: "https://www.linkedin.com/company/valletech-ab"
};
